/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { AllManufacturer } from './TableHead';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  REBATE_SELECT,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  tabHighLigther,
  convertToFourDigitYear,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getManufacturerList,
  getResultGridChipCshcnRates,
  setChipCshcnReport,
  getChipCshcnRatesMaxQtr,
} from '../Store/actions';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqChipCshcnRates(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    rebateProgramNameValue,
    manufacturerList: resultanufacturerList,
    selectedRowIndexValue,
    searchResult,
    chipCshcnMaxQuarter,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      quarterValue,
      isAllManufacturersSelected: isAllManufacturersSelectedValue,
      scrollDownManufacturers: scrollDownManufacturersValue,
    },
  } = useSelector((state) => state?.sharedState?.ChipCshcnRatesReducer);

  const [quarter, setQuarter] = React.useState(quarterValue);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(isAllManufacturersSelectedValue);

  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [errorList, setErrorList] = React.useState(errors);
  const [selectedRowIndex, setSelectedRowIndex] = React.useState(
    selectedRowIndexValue
  );

  // To know that search button is pressed
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const [manufacturerSelected, setManufacturerSelected] = React.useState([
    'ALL',
  ]);
  const [scrollDownManufacturers, setScrollDownManufacturers] = useState(
    scrollDownManufacturersValue
  );
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  // For No Data validation
  // React.useEffect(() => {
  //   setErrorList(errors);
  // }, [errors]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });

      // Filter out the 'FD' option
      const filteredPlanList = planList.filter((obj) => obj.value !== 'FD');

      setRadioList([
        ...filteredPlanList.filter((obj) => obj.value === 'ST'),
        ...filteredPlanList.filter((obj) => obj.value === 'SUPP'),
        ...filteredPlanList.filter((obj) => obj.value === 'COMM'),
      ]);

      const tempPlanType = filteredPlanList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      if (!planType || planType === 'FD') {
        // Set default plan type, ensuring it is not 'FD'
        if (userDefaults?.planTypeCd === 'FD' || !tempPlanType) {
          setPlanType(null); // No radio button selected
          setRebateProgram('-1');
          setRebateProgramName('');
        } else {
          setPlanType(planType || tempPlanType?.value);
        }
      }
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  // After each time once plantype changes rebateprogram list get updated using this API call
  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // Calling API to get the Max Quarter
  React.useEffect(() => {
    dispatch(getChipCshcnRatesMaxQtr());
  }, []);

  // To set the quarter variable
  React.useEffect(() => {
    if (chipCshcnMaxQuarter) {
      setQuarter(quarterValue || chipCshcnMaxQuarter);
    }
  }, [chipCshcnMaxQuarter]);

  // To get manufacturer List
  // React.useEffect(() => {
  //   dispatch(
  //     getManufacturerList({
  //       planType: 'fd',
  //       asMode: 1,
  //     })
  //   );
  // }, []);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // To change the manufacturer grid as per the plan type selection
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
  };

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
    let localErrors = errorList;
    if (type === 'qtr') {
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      const qtrErr = validateQuarter(value, 'qtr',true);
      if (qtrErr.length === 0) {
        const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
        setQuarter(qtr);
      } else {
        localErrors = [...localErrors, ...qtrErr];
      }
    }
    setErrorList(localErrors);
  };

  // On selection of the row data
  const onSelectionChanged = (e) => {
    const manuError = [];
    const selectedRows = e.api?.getSelectedRows();
    const selectedMfgId = selectedRows?.map((item) => item.mfgId);
    const selectedIndexes = [];
    manufacturerList.forEach((item, index) => {
      if (selectedMfgId?.indexOf(item.mfgId) != -1) {
        selectedIndexes.push(index);
      }
    });
    setSelectedRowIndex(selectedIndexes);

    if (
      selectedRows?.length === manufacturerList.length
      // || selectedRows.length === 0
    ) {
      setManufacturerSelected(['ALL']);
    } else {
      const selectedManuId = [];
      for (let i = 0; i < selectedRows?.length; i++) {
        selectedManuId.push(selectedRows[i].mfgId);
      }
      selectedManuId.sort();
      setManufacturerSelected(selectedManuId);
    }
    setErrorList(manuError);
  };

  // const displayChipCshcnRates = () => {

  // };
  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = () => {
    let allErrors = [];
    const manuError = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    if (manufacturerSelected.length === 0) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    allErrors = [...allErrors, ...errorList];

    setErrorList(allErrors);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgramName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgramName = `${rebateProgramName?.rebateProgramCd} - ${
      rebateProgramName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramName,
        manufacturerSelected,
        quarterValue: quarter,
        isAllManufacturersSelected,
        selectedRowIndexValue: selectedRowIndex,
        scrollDownManufacturers,
        searchScreenVar: {
          rebateProgramName,
          rebateProgramValue: rebateProgram,
          selectedPlanType: planType,
          quarterValue: quarter,
          isAllManufacturersSelected,
          scrollDownManufacturers,
        },
      })
    );

    if (allErrors.length === 0) {
      dispatch(setChipCshcnReport([]));
      setSearchClicked(true);
      dispatch(
        getResultGridChipCshcnRates({
          rebateProgramCd: rebateProgram,
          quarter: quarter,
          mfgId: manufacturerSelected,
          alAll: manufacturerSelected[0] === 'ALL' ? 1 : 0,
        })
      );
      // if (searchResult?.length > 0) {
      // displayChipCshcnRates();
      // }
    }
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */

    if (allErrors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
    if (isSearchClicked && errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errors]);
  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/dispChipCshcnReport',
      value: 'Display CHIP/CSHCN Rates',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/dispChipCshcnReport',
    });
    dispatch(clearReduxForFilterAndSort('/dispChipCshcnReport'));
  }
    
  //remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [planType, planTypeList, rebateProgram, quarter, isAllManufacturersSelected, scrollDownManufacturers, fullScreenView]);

  // const errorElem = document.getElementById('errorScroll');
  // if (errorElem && errorList.length > 0) {
  //   setTimeout(() => {
  //     errorElem.scrollIntoView();
  //   }, 1000);
  // }

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  return (
    <div className="tabs-container">
      {!fullScreenView && (
        <div className="tab-body">
          <Spinner load={isLoading} />
          {/* <div id="errorScroll"> */}
          <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
          {/* </div> */}
          <CustomSeparator parent1="State Reports" parent2="CHIP/CSHCN Rates" />

          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="chip-cshcn-Rebate-Program"
                id="filter-plan-by-radio-btn-action"
                labelName="Plan Type"
                required={false}
                optionList={radioList || []}
                defaultValue={planType}
                filterAction={(value) => {
                  setPlanType(value);
                  setRebateProgram('-1');
                  handleOnChangeEvent(value, 'planTypeCd');
                  const errors = errorList.filter(
                    (error) => error.field !== 'rebateProgram'
                  );
                  setErrorList([...errors]);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4">
              <>
                <Fieldset label="Rebate Program" required>
                  <div>
                    <SelectBoxComponent
                      data-testid="chip-chscn-plan-by-radio-btn-plan"
                      id="filter-plan-by-radio-btn-action"
                      labelName="Rebate Program"
                      required
                      select
                      selectOne
                      optionList={selectList || []}
                      defaultValue={rebateProgram}
                      filterAction={(value) => {
                        setRebateProgram(value);
                        setRebateProgramName(value);
                        const errors = errorList.filter(
                          (error) => error.field !== 'rebateProgram'
                        );
                        setErrorList([...errors]);
                      }}
                      isError={
                        errorList.find(
                          (error) => error.field === 'rebateProgram'
                        )?.message
                      }
                    />
                  </div>
                </Fieldset>
              </>
            </div>
            <div className="col-3 mt-2">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  label="Quarter"
                  id="Quarter"
                  data-testid="req-NDC-payment-quarter"
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ maxLength: 6 }}
                  required
                  name="qtr"
                  value={quarter}
                  error={
                    errorList.filter((error) => error.field === 'qtr')?.length >
                    0
                      ? 'mandate-fields'
                      : ''
                  }
                  helperText={
                    errorList.find((error) => error.field === 'qtr')?.message
                  }
                  className="mandate-fields"
                  onBlur={(e) => handleOnBlur('qtr', e.target.value)}
                  onChange={(e) => {
                    const { value } = e.target;
                    setQuarter(value.toUpperCase());
                    const localErrors = errorList.filter(
                      (error) => error.field != 'qtr'
                    );
                    setErrorList(localErrors);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row ml-2 mt-3">
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllManufacturersSelected}
                    color="primary"
                    name="allManufacturers"
                    // onBlur={(e) => {
                    //   handleOnblurEvent('manufacturer', e.target.value);
                    // }}
                    onChange={ async (e) => {
                      setIsAllManufacturersSelected(
                        !isAllManufacturersSelected
                      );

                      setScrollDownManufacturers(!scrollDownManufacturers);
                      if (!isAllManufacturersSelected) {
                        setManufacturerSelected(['ALL']);
                      } else {
                        setManufacturerSelected([]);
                      }

                      const elem = document.getElementById('abc11');
                      if (elem && scrollDownManufacturers) {
                        await PromiseRejectionEvent.resolve();
                        // setTimeout(() => {
                          elem.scrollIntoView();
                        // }, 1000);
                      }
                      const errors = errorList.filter(
                        (error) => error.field !== 'manufacturer'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'manufacturer')
                        ?.message
                    }
                  />
                }
                label="All Manufacturers"
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: 15 }}>
            <div className="btn-wrapper col-12">
              <Button
                onClick={handleSearchClick}
                className="btn btn-success btn-search float-right"
              >
                <SVGComponent iconName="Icon-search" /> Search
              </Button>
            </div>
          </div>
        </div>
      )}
      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              selectRowIndex={selectedRowIndexValue}
              // cellClickedListener={cellClickedListener}
              rowData={manufacturerList || []}
              helpMessage
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={AllManufacturer}
              rowSelection="multiple"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
            />
          </div>
        )}
      </div>
    </div>
  );
}
